import { createFileRoute } from "@tanstack/react-router";
import { BadgeScene } from "@/components/badge/badge-scene";

export const Route = createFileRoute("/card")({
  head: () => ({
    meta: [
      { title: "Jonathan Osburg — Contact card" },
      {
        name: "description",
        content:
          "Jon Osburg, founder of the Vibing Company. Phone, email, socials, and one tap to save his contact card.",
      },
      // A personal share utility, not a findable page. Stays out of the sitemap too.
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Jonathan Osburg — Contact card" },
      { property: "og:type", content: "profile" },
      { name: "twitter:card", content: "summary" },
      {
        property: "og:description",
        content: "Founder of the Vibing Company. Save his contact details in one tap.",
      },
    ],
  }),
  component: CardPage,
});

function CardPage() {
  return (
    <main className="card-page-dots relative flex min-h-svh flex-col overflow-hidden bg-background text-foreground">
      <BadgeScene />
    </main>
  );
}
